var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',[_c('div',{staticClass:"no-data-message"},[_vm._v("Главная страница системы аналитики")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }